// 错误类型配色与样式工具

// 固定颜色类名集合，和标签类似但使用不同配色，保证可读性
const ERROR_COLOR_CLASSES = [
  'error-color-1',
  'error-color-2',
  'error-color-3',
  'error-color-4',
  'error-color-5',
  'error-color-6',
  'error-color-7',
  'error-color-8',
  'error-color-9',
  'error-color-10'
]

// 根据 error_code 计算颜色 class（稳定映射）
export function getErrorColorClass(errorCode) {
  if (!errorCode) return ERROR_COLOR_CLASSES[0]
  try {
    const parts = String(errorCode).split('_')
    const tail = parts[1] || errorCode
    const index = parseInt(tail, 36)
    return ERROR_COLOR_CLASSES[index % ERROR_COLOR_CLASSES.length]
  } catch (e) {
    return ERROR_COLOR_CLASSES[0]
  }
}

// 错误类型固定配色方案 - 按错误性质分配颜色
const ERROR_TYPE_COLORS = {
  '1-算法未掌握': { backgroundColor: '#E74C3C', borderColor: '#E74C3C', color: 'white' },      // 红色 - 基础问题，最严重
  '2-思路/逻辑偏差': { backgroundColor: '#F39C12', borderColor: '#F39C12', color: 'white' },   // 橙色 - 思维问题，需要重视
  '3-实现/细节错误': { backgroundColor: '#F1C40F', borderColor: '#F1C40F', color: 'white' },   // 黄色 - 实现问题，可以改进
  '4-效率/复杂度问题': { backgroundColor: '#9B59B6', borderColor: '#9B59B6', color: 'white' }, // 紫色 - 优化问题，进阶内容
  '5-边界/特殊情况遗漏': { backgroundColor: '#3498DB', borderColor: '#3498DB', color: 'white' }, // 蓝色 - 细致性问题
  '6-题意理解偏差': { backgroundColor: '#E67E22', borderColor: '#E67E22', color: 'white' },   // 深橙 - 理解问题
  '7-工具/环境问题': { backgroundColor: '#1ABC9C', borderColor: '#1ABC9C', color: 'white' },   // 青色 - 外部因素
  '8-心理性错误': { backgroundColor: '#E91E63', borderColor: '#E91E63', color: 'white' },      // 粉红 - 心理因素
  '9-其他/暂未分类错误': { backgroundColor: '#95A5A6', borderColor: '#95A5A6', color: 'white' }, // 灰色 - 未分类
  '未定义': { backgroundColor: '#BDC3C7', borderColor: '#BDC3C7', color: 'white' }             // 浅灰 - 未定义
}

// 根据错误类型名称直接获取颜色
export function getErrorTypeColor(errorTypeName) {
  return ERROR_TYPE_COLORS[errorTypeName] || ERROR_TYPE_COLORS['未定义']
}

// 直接生成内联样式（可用于 el-tag 的 :style）
export function getErrorStyleByClass(className) {
  const map = {
    // 调整为更高区分度的配色（蓝/绿/橙/红/紫/青/金/靛/深绿/岩灰）
    'error-color-1': { backgroundColor: '#1E90FF', borderColor: '#1E90FF', color: 'white' },   // 亮蓝
    'error-color-2': { backgroundColor: '#00B894', borderColor: '#00B894', color: 'white' },   // 亮绿青
    'error-color-3': { backgroundColor: '#F39C12', borderColor: '#F39C12', color: 'white' },   // 明橙
    'error-color-4': { backgroundColor: '#E74C3C', borderColor: '#E74C3C', color: 'white' },   // 鲜红
    'error-color-5': { backgroundColor: '#8E44AD', borderColor: '#8E44AD', color: 'white' },   // 紫色
    'error-color-6': { backgroundColor: '#2ECC71', borderColor: '#2ECC71', color: 'white' },   // 草绿色
    'error-color-7': { backgroundColor: '#D35400', borderColor: '#D35400', color: 'white' },   // 深橙
    'error-color-8': { backgroundColor: '#2980B9', borderColor: '#2980B9', color: 'white' },   // 深蓝
    'error-color-9': { backgroundColor: '#16A085', borderColor: '#16A085', color: 'white' },   // 深青
    'error-color-10': { backgroundColor: '#34495E', borderColor: '#34495E', color: 'white' }   // 岩灰
  }
  return map[className] || map['error-color-1']
}

export function getErrorTagInlineStyle(errorCode) {
  const cls = getErrorColorClass(errorCode)
  return getErrorStyleByClass(cls)
}

// 描边/空心样式：透明背景、同色描边与文字
export function getErrorOutlineStyle(errorCode) {
  const solid = getErrorTagInlineStyle(errorCode)
  const color = (solid && solid.backgroundColor) || '#1E90FF'
  return {
    backgroundColor: 'transparent',
    borderColor: color,
    color: color
  }
}

